module.exports = __webpack_public_path__ + "media/public/fonts/QanelasThin/QanelasThin-a2a750b35e82b1a0c142c13821160be0.eot";